import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { Button, LinkButton } from '@/components/buttons';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { ReturnToLink } from '@/components/ReturnToLink';
import { ROUTES } from '@/router';

type Props = {
  isTAMAudience?: boolean;
  isCreatingAudience: boolean;
  onPreview: () => void;
};

const CreateRuleBasedAudienceHeader = ({
  isTAMAudience = false,
  isCreatingAudience,
  onPreview,
}: Props) => {
  return (
    <div className="flex items-center justify-between gap-8 max-md:flex-col max-md:items-start max-md:gap-4">
      <ReturnToLink
        route={isTAMAudience ? ROUTES.companySettings.path : ROUTES.audiences.path}
        routeName={isTAMAudience ? t`Company Settings` : t`Audiences`}
      />
      <div className="flex items-center gap-4 max-md:w-full max-md:justify-end">
        <PendoPlaceholder />
        <LinkButton to={isTAMAudience ? ROUTES.companySettings.path : ROUTES.audiences.path}>
          <Trans>Cancel</Trans>
        </LinkButton>
        <Button onClick={onPreview}>
          <Trans>Preview</Trans>
        </Button>
        <Button
          variant="primary"
          disabled={isCreatingAudience}
          isLoading={isCreatingAudience}
          type="submit"
        >
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  );
};

export default CreateRuleBasedAudienceHeader;
